import { createAction } from '@reduxjs/toolkit'
import isUndefined from 'lodash/isUndefined'
import { call, put, select, StrictEffect, takeEvery } from 'redux-saga/effects'

import { updateSingleDocumentMapping } from './updateSingleDocumentMapping'
import { DocumentMapping } from '../../../models/documentMapping'
import { selectDocumentMappings, selectDocumentOrderDict, updateDocumentOrderForIds } from '../../slices/documents'

export const movePlanPageAction = createAction<{
    buildingId: number
    pageId: number
    targetId: number | string
}>('movePlanPage')

type DocumentOrderDict = ReturnType<typeof selectDocumentOrderDict>

export function* handleMovePlanPage(action: ReturnType<typeof movePlanPageAction>) {
    try {
        const { buildingId, pageId, targetId } = action.payload

        const documentMappings: DocumentMapping[] | null = yield select(selectDocumentMappings)
        const orderDict: DocumentOrderDict = yield select(selectDocumentOrderDict)

        const documentMapping = documentMappings?.find((dm) => dm.document_chunk_id === pageId)
        const newOrder = orderDict[targetId]

        if (!documentMapping) return

        if (documentMapping.building_id === buildingId) {
            if (isUndefined(newOrder)) return

            yield put(
                updateDocumentOrderForIds({
                    ids: [documentMapping.id, documentMapping.document_chunk_id],
                    newOrder: newOrder - 1,
                })
            )

            return
        }

        yield put(
            updateSingleDocumentMapping({
                ...documentMapping,
                building_id: buildingId,
            })
        )
    } catch (error) {
        yield call(console.error, error)
    }
}

export function* watchForMovePlanPage(): Generator<StrictEffect, void, unknown> {
    yield takeEvery(movePlanPageAction.type, handleMovePlanPage)
}
